import { createReducer } from 'utils'
import { fromJS } from 'immutable'

import { constants } from 'common/actions/systems'
import { ADD_ALERT_RECIPIENT_REQUEST } from 'common/actions/user'

import { RESET_ERROR } from 'common/actions/error'

export const initialState = fromJS({
  isSubmitting: false,
  isAddingEmail: false,
  error: null
})

export default createReducer(initialState, {
  [RESET_ERROR]: state => state.set('error', null),

  [constants.CREATE_ALARM_REQUEST.START]: state => state.set('isSubmitting', true),
  [constants.CREATE_ALARM_REQUEST.SUCCESS]: () => initialState,
  [constants.CREATE_ALARM_REQUEST.FAILURE]: (state, { payload: error }) => {
    return state.set('isSubmitting', false).set('error', error)
  },

  [ADD_ALERT_RECIPIENT_REQUEST.START]: state => state.set('isAddingEmail', true),
  [ADD_ALERT_RECIPIENT_REQUEST.SUCCESS]: () => initialState,
  [ADD_ALERT_RECIPIENT_REQUEST.FAILURE]: state => state.set('isAddingEmail', false)
})
